import { type Message, textOf } from "./api";

export type ExportFormat = "md" | "json" | "txt";

/** Conversation → file content (Markdown by default; JSON keeps everything; TXT is plain). Pure, so it is unit-tested. */
export function conversationToText(
  title: string,
  messages: Message[],
  format: ExportFormat,
  names = { user: "You", assistant: "AI" },
): string {
  const rows = messages
    .map((m) => ({
      role: m.role,
      text: textOf(m.content).trim(),
      model: m.model ?? null,
      at: m.createdAt,
    }))
    .filter((r) => r.text);
  if (format === "json")
    return JSON.stringify({ title, exportedAt: new Date().toISOString(), messages: rows }, null, 2);
  if (format === "txt")
    return `${title}\n${"=".repeat(Math.min(60, title.length))}\n\n${rows
      .map((r) => `${r.role === "user" ? names.user : names.assistant}:\n${r.text}`)
      .join("\n\n---\n\n")}\n`;
  return `# ${title}\n\n${rows
    .map(
      (r) =>
        `**${r.role === "user" ? names.user : names.assistant}**${r.model ? ` · ${r.model}` : ""}\n\n${r.text}`,
    )
    .join("\n\n---\n\n")}\n`;
}

export function safeFilename(title: string) {
  return (
    title
      .replace(/[\\/:*?"<>|\n\r]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 60) || "chat"
  ).replace(/ /g, "-");
}

export function downloadText(filename: string, content: string, mime: string) {
  const url = URL.createObjectURL(new Blob(["﻿", content], { type: `${mime};charset=utf-8` }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
